import React from 'react'

import { Tooltip } from '../../../module'
import Menu, { type MenuActionProps } from '../Menu'
import { IconAndName } from '../Menu'
import {
  type TooltipProps as ActualTooltipProps,
  Icon,
  type IconStringList,
} from '../../../module'

interface SubMenuProps {
  text: string
  icon?: IconStringList
  destructive?: boolean
  disabled?: { value: boolean; tooltip?: Omit<ActualTooltipProps, 'children'> }
  hasDivider?: boolean
  subMenuActions: MenuActionProps[]
  className: string
  closeParentMenu?: () => void
  /** Optional prop to add a test id to the SubMenu for QA testing */
  qaTestId?: string
}

const SubMenu: React.FC<SubMenuProps> = ({
  text,
  icon,
  destructive,
  disabled,
  subMenuActions,
  className,
  closeParentMenu,
  qaTestId,
}) => {
  const enhancedSubMenuActions = subMenuActions.map((action) => {
    if (action.callout && typeof action.callout === 'function') {
      const originalCallout = action.callout
      return {
        ...action,
        callout: () => {
          originalCallout()
          closeParentMenu?.()
        },
      }
    }
    return action
  })

  return (
    <Tooltip
      position='right-start'
      noPadding
      tooltipContent={({ setVisible }) => (
        <Menu
          actions={enhancedSubMenuActions}
          close={() => setVisible(false)}
          qaTestId={qaTestId}
        />
      )}
      qaTestId={qaTestId}
    >
      <div
        className={className}
        role='button'
        tabIndex={disabled?.value ? -1 : 0}
        aria-disabled={disabled?.value}
        aria-haspopup='menu'
      >
        <IconAndName text={text} icon={icon} destructive={destructive} />
        <Icon icon='caretRight' iconSize='16px' />
      </div>
    </Tooltip>
  )
}

export default SubMenu
